export default {
  INSPECTION_REPORT: 'Inspection Report',
};
